import { Constant } from "utils/enums";
import { createBrandDetail, getBrandByCategoryId, getBrands, getBrandsCopy, getCategories, getSellerBrands } from "helpers/backend_helper";
import { useNavigate } from 'react-router-dom';
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    searchAllBrands as searchBrandFN,
  } from "../../helpers/backend_helper";
import { toast } from "react-toastify";

export const createBrand = (business: any , navigate: any) => async (dispatch: any) => { 
    // const navigate = useNavigate();
    try {
      const brandDetails = {
        brandId: business.brandId,
        brandName: business.brandName, 
        brandCategoryId: business.brandCategoryId, 
        relation: business.relation,
        brandAuthenticationDocument: business.brandAuthenticationDocument, 
        socialMediaLink: business.socialMediaLinks,
        startDate: business.startDate,
        endDate: business.endDate,
        trademarkNumber: business.trademarkNumber,
      };
      let response: any = await createBrandDetail(brandDetails);
      if (response && response.isSuccess) {
        navigate('/brands');
        toast.success(response.message)
      }else{
        toast.error("Brand Added Failed")
      }
    } catch (error: any) {
    }
  };

  // export const searchCategoriesFunc = createAsyncThunk("brand/searchBrandFN", async (keyword: string) => {
  //   try {
  //     const response = await searchBrandFN(keyword);
  //     return response.data;
  //   } catch (error) {
  //     return [];
  //   }
  // });

  // export const clearSearchCategoriesFunc = createAsyncThunk("brand/clearSearchBrandFunc", () => {
  //   return [];
  // });
  
  export const getBrandThunk = createAsyncThunk("brand/getBrands", async() => {
    try {
      const response = await getBrands(1, 100 );
      const data = response.data;
      return { brands: data};
    } catch (error) {
      return error;
    }
  });

  export const getBrandCopyThunk = createAsyncThunk("brand/getBrands", async({page, count,keyword} : {page: number, count: number, keyword: string}) => {
    try {
      const response = await getBrandsCopy(page, count, keyword);
      const data = response.data;
      return { brands: data};
    } catch (error) {
      return error;
    }
  });


  export const getBrandCategoryIdByThunk = createAsyncThunk("brand/getBrands", async({categoryId} : {categoryId : any}) => {
    try {
      const response = await getBrandByCategoryId(1, 100 , categoryId);
      const data = response.data;
      return { brands: data};
    } catch (error) {
      return error;
    }
  });
  
  export const getSellerBrandThunk = createAsyncThunk(
    "brand/getSellerBrands",
    async ({ page, count, status, keyword, relation }: {page: number, count: number, status: string, keyword: string, relation: string }) => {
      try {
        const response = await getSellerBrands(page, count, status, keyword, relation);
        return response.data
        // const { data ,counts } = response.data;
        // return { sellerBrands: data,counts };
      } catch (error) {
        return error;
      }
    }
  );

  export const getBrandCategory = createAsyncThunk(
    "categorySeller/get",
    async () => {
      try {
        const response = await getCategories("");
        const data = response.data;
        return { brandCategory: data };
      } catch (error) {
        throw error;
      }
    }
  );
  